/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type CitationInput = {
  page?: string | null | undefined;
};

export type EvidenceUpsertInput = {
  citation?: CitationInput | null | undefined;
  id?: string | null | undefined;
  referenceId: string;
};

export type GeoItemCoords = {
  lat: number;
  lng: number;
};

export type GeoItemUpdateInput = {
  coords?: GeoItemCoords | null | undefined;
  countryCode?: string | null | undefined;
  countrySubdivisionCode?: string | null | undefined;
  entityOrRelationId?: string | null | undefined;
  geometry?: Types.JsonObject | null | undefined;
  h3Indexes?: Array<string> | null | undefined;
  i18nLabel?: I18nLabelInput | null | undefined;
  id: string;
  metadata?: Types.JsonObject | null | undefined;
  recordEndDate?: string | null | undefined;
  recordI18nLabel?: I18nLabelInput | null | undefined;
  recordStartDate?: string | null | undefined;
  tenantId: string;
};

export type I18nLabelCanonicalInput = {
  locale: string;
  value: string;
};

export type I18nLabelInput = {
  canonical?: Array<I18nLabelCanonicalInput> | null | undefined;
  en?: string | null | undefined;
  ja?: string | null | undefined;
};

export type RecordGeoItemUpdateInput = {
  endDate?: string | null | undefined;
  entityOrRelationId: string;
  evidences?: Array<EvidenceUpsertInput> | null | undefined;
  geoItemId: string;
  i18nLabel?: I18nLabelInput | null | undefined;
  metadata?: Types.JsonObject | null | undefined;
  startDate?: string | null | undefined;
  tenantId: string;
};

export type UpdateRecordGeoItemMutationVariables = Exact<{
  input: Types.RecordGeoItemUpdateInput;
  geoItemInput: Types.GeoItemUpdateInput;
}>;


export type UpdateRecordGeoItemMutation = { cnutUpdateGeoItem: { __typename: 'GeoItemOutput', id: string }, cnutUpdateRecordGeoItem: { __typename: 'RecordGeoItemOutput', geoItemId: string, entityOrRelationId: string } };


export const UpdateRecordGeoItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRecordGeoItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecordGeoItemUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"geoItemInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoItemUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutUpdateGeoItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"geoItemInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cnutUpdateRecordGeoItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"geoItemId"}},{"kind":"Field","name":{"kind":"Name","value":"entityOrRelationId"}}]}}]}}]} as unknown as DocumentNode<UpdateRecordGeoItemMutation, UpdateRecordGeoItemMutationVariables>;